import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BOOKING_LOGS, GET_BOOKING_LOGS_SUCCESS, GET_BOOKING_LOGS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBookingLogs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId, membershipId, benefitConfigId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/booking-activities?membership_id=${membershipId}&benefit_config_id=${benefitConfigId}`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_LOGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_LOGS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_LOGS_ERROR, payload: error });
  }
}

export function* watchGetBookingLogs() {
  yield takeEvery(GET_BOOKING_LOGS, getBookingLogs);
}

function* getBookingLogsSaga() {
  yield all([fork(watchGetBookingLogs)]);
}

export default getBookingLogsSaga;
